// extracted by mini-css-extract-plugin
module.exports = {"field":"BankVerified-module__field___3ZR1v","subtitle":"BankVerified-module__subtitle___FGceM","bankVerifiedButtonGrid":"BankVerified-module__bankVerifiedButtonGrid___f4upx"};